import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import SeniorSetting from './SeniorSetting';
import SeniorSearch from './SeniorSearch';
import BaseColumn from './BaseColumn';
import SeniorColumn from './SeniorColumn';
import BaseTrunPage from './BaseTrunPage';
import { mapGetters } from 'vuex';
import util from '@/libs/util';
var props = {
  size: {
    type: String,
    default: 'medium'
  },
  cellClassName: {
    type: String,
    default: null
  },
  // 是否启用自定义列
  isColumn: {
    type: Boolean,
    default: true
  },

  /**
   * @name: 表格数据
   * @param {Array} 数组对象
   * @return {*}
   */
  data: {
    type: Array,
    required: true
  },

  /**
   * @name: 表格loading
   * @param {Boolean} 是否loading
   * @return {Boolean} false
   */
  loading: {
    type: Boolean,
    default: false
  },

  /**
   * @name: 表格头部配置是否显示
   * @param {Boolean} 是否显示配置
   * @return {Boolean} { type: Boolean, default: true }
   */
  toolbar: {
    type: Boolean,
    default: null
  },

  /**
   * @name: 鼠标配置项
   * @param {boolean} selected[开启单元格选中功能
   * @param {boolean} area[如果功能被支持，则开启鼠标左键单元格区域选取功能，非连续的区域，同时按住 鼠标左键 + Ctrl 键，用鼠标逐一选取
   * @param {boolean} extension[只对 area 启用后有效，是否开启区域扩展选取功能，开启后可以通过鼠标左键按住区域内右下角扩展按钮，将区域横向或纵向扩大（支持扩大区域并复制值）
   * @return {Object} { selected: true }
   */
  mouseConfig: {
    type: Object,
    default: function _default() {
      return {
        selected: true
      };
    }
  },

  /**
   * @name: 自定义行数据唯一主键的字段名
   * @param {string} rowId[唯一主键的字段名
   * @return {string} null
   */
  rowId: {
    type: String,
    default: null
  },

  /**
   * @name: 是否显示翻页配置
   * @param {string} isTrunPage[翻页配置
   * @return {string} false
   */
  isTrunPage: {
    type: Boolean,
    default: false
  },
  cellstyle: {
    type: Object,
    default: function _default() {
      return {};
    }
  },

  /**
   * @name: 可编辑配置项
   * @param {string} trigger[触发方式
   * @param {boolean} enabled[是否启用
   * @return {*} {
   * trigger: 'click',
   * mode: 'row',
   * showStatus: true }
   */
  editConfig: {
    type: Object,
    default: function _default() {
      return {
        trigger: 'click',
        mode: 'row',
        showStatus: true
      };
    }
  },

  /**
     * @name: 是否启用单选框
     */
  radio: {
    type: Boolean,
    default: false
  },

  /**
   * @name: 单选框配置项
   * @param {Boolean} strict[严格模式，选中后不能取消
   * @param {Boolean} reserve[严格模式，是否保留勾选状态，例如：数据被刷新或者分页之后还保留之前选中的状态（需要有 row-id）
   * @param {string} labelFieldd[单选框显示的字段名，可以直接显示在单选框中
   * @param {string} checkRowKey[默认选中指定行（只会在初始化时被触发一次，需要有 row-id）
   * @param {Boolean} checkMethod[是否允许选中的方法，该方法的返回值用来决定这一行的 Radio 是否可以选中
   * @param {string} trigger[触发方式
   * @param {Boolean} highlight[高亮选中行
   * @return {Object} { labelField: 'name', trigger: 'row' }
   */
  radioConfig: {
    type: Object,
    default: function _default() {
      return {
        labelField: 'name',
        trigger: 'row'
      };
    }
  },

  /**
     * @name: 是否启用复选框
     */
  checkbox: {
    type: Boolean,
    default: false
  },

  /**
   * @name: 复选框配置项
   * @param {string} labelField[复选框显示的字段名
   * @param {string} checkField[绑定选中属性
   * @param {boolean} showHeader[是否显示全选按钮
   * @param {boolean} checkAll[默认勾选所有
   * @param {Array} checkRowKeys[默认勾选指定行
   * @param {string} trigger[触发方式default（默认）, cell（点击单元格触发）, row（点击行触发）
   * @param {boolean} highlight[高亮勾选行
   * @param {boolean} reserve[是否保留勾选状态
   * @param {boolean} range[开启复选框范围选择功能
   * @return {Object} { checkField: 'checked', trigger: 'row' }
   */
  checkboxConfig: {
    type: Object,
    default: function _default() {
      return {
        checkField: null,
        trigger: 'row'
      };
    }
  },

  /**
   * @name: 打印配置
   * @param {String} sheetName[表名
   * @param {String} mode[输出数据方式
   * @param {String} modes[输出数据列表
   * @param {String} original[是否为源数据
   * @param {String} isHeader[是否需要表头
   * @param {boolean} isFooter[是否需要表尾
   * @param {boolean} isMerge[支持临时合并的单元格
   * @param {*} data[指定数据
   * @param {Array} columns[指定列
   * @param {String} style[只对 type=html 有效
   * @param {String} content[自定义打印的内容
   * @return {Object}
   */
  printConfig: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  validRules: {
    type: Object,
    default: function _default() {
      return {};
    }
  },

  /**
   * @description 是否可改变表格高度
   */
  resizeAble: {
    type: Boolean,
    default: false
  },
  pageInfo: {
    type: Object,
    default: function _default() {
      return {
        TotalCount: 1,
        PageSize: 10,
        PageIndex: 1
      };
    }
  },
  isShowPagination: {
    type: Boolean,
    default: true
  }
};
export default {
  name: 'MesTable',
  data: function data() {
    return {
      ParamList: {},
      seniorDrawer: false,
      dialogVisible: false,
      fullscreen: false,
      fullNum: 0,
      zoomIcon: 'vxe-icon--zoomin',

      /* table选中keys */
      selectedRowKeys: [],

      /* table选中records */
      records: [],
      exportConfig: {},
      ParamListNew: []
    };
  },
  components: {
    SeniorSetting: SeniorSetting,
    SeniorSearch: SeniorSearch,
    BaseColumn: BaseColumn,
    SeniorColumn: SeniorColumn,
    BaseTrunPage: BaseTrunPage
  },
  computed: _objectSpread({}, mapGetters(['routerPath'])),
  props: props,
  provide: function provide() {
    return {
      ParamList: this.ParamList,
      isColumn: this.isColumn
    };
  },
  // watch: {
  //   ParamList: {
  //     handler (newVal) {
  //       console.log(this.ParamList)
  //       console.log(newVal)
  //     },
  //     deep: true
  //   }
  // },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      if (_this.fullscreen) {
        _this.fullNum++;

        if (_this.fullNum > 1) {
          _this.fullscreen = false;
          _this.fullNum = 0;
          _this.zoomIcon = 'vxe-icon--zoomin';
          var tableContainer = document.querySelector('.table-container');

          if (tableContainer) {
            tableContainer.removeAttribute('style');
          }
        }
      } else {
        _this.fullNum = 0;
      }
    };

    console.log('return', this.rowClassName);
  },
  methods: {
    setParamListNewByParam: function setParamListNewByParam() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var currentParamIndex = this.ParamListNew.findIndex(function (e) {
        return e.PARAM_NAME === param.PARAM_NAME;
      });

      if (currentParamIndex === -1) {
        this.ParamListNew.push(param);
      } else {
        this.ParamListNew[currentParamIndex] = param;
      }
    },
    handleSeniorSearch: function handleSeniorSearch() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.$emit('SeniorSearch', val);
    },
    handleExportData: function handleExportData() {
      console.log('this.data', this.data);
      console.log(this.$refs.xTable.exportData);
      this.$refs.xTable.exportData({
        // filename: '委外订单报表',
        // sheetName:'123',
        // type: 'txt',
        data: this.data // isHeader: true,
        // isFooter: true,

      });
    },
    handleCurrentChange: function handleCurrentChange(index) {
      this.$emit('handleCurrentChange', index);
    },
    handleSizeChange: function handleSizeChange(size) {
      this.$emit('handleSizeChange', size);
    },
    toggle: function toggle() {
      var elem = document.querySelector('.d2-container-full'); // var fullHeader = document.querySelector('.d2-container-full__header')

      var fullHeader = document.querySelector('.List-header');
      var tableContainer = document.querySelector('.table-container'); // console.log('elem',elem);
      // console.log('fullHeader',fullHeader);
      // console.log('tableContainer',tableContainer);

      this.fullscreen = !this.fullscreen;

      if (this.fullscreen) {
        fullHeader.style.display = 'none';

        if (tableContainer) {
          tableContainer.style.height = '90vh';
        }

        this.requestFullScreen(elem);
        this.zoomIcon = 'vxe-icon--zoomout';
      } else {
        fullHeader.removeAttribute('style');

        if (tableContainer) {
          tableContainer.removeAttribute('style');
        }

        this.exitFull();
        this.zoomIcon = 'vxe-icon--zoomin';
      }
    },
    requestFullScreen: function requestFullScreen(element) {
      // 判断各种浏览器，找到正确的方法
      var requestMethod = element.requestFullScreen || // W3C
      element.webkitRequestFullScreen || // Chrome等
      element.mozRequestFullScreen || // FireFox
      element.msRequestFullScreen; // IE11

      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for Internet Explorer
        // eslint-disable-next-line no-undef
        var wscript = new ActiveXObject('WScript.Shell');

        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    },
    // 退出全屏 判断浏览器种类
    exitFull: function exitFull() {
      // 判断各种浏览器，找到正确的方法
      var exitMethod = document.exitFullscreen || // W3C
      document.mozCancelFullScreen || // Chrome等
      document.webkitExitFullscreen || // FireFox
      document.webkitExitFullscreen; // IE11

      if (exitMethod) {
        exitMethod.call(document);
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for Internet Explorer
        // eslint-disable-next-line no-undef
        var wscript = new ActiveXObject('WScript.Shell');

        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    },
    handleParamList: function handleParamList() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.$emit('ParamList', val);
    },
    handleRefreshReset: function handleRefreshReset() {
      var _this2 = this;

      if (JSON.stringify(this.ParamList) !== '{}') {
        Object.keys(this.ParamList).map(function (keys) {
          _this2.ParamList[keys] = null;
        });
      }
    },
    RadioChange: function RadioChange(_ref) {
      var newValue = _ref.newValue,
          oldValue = _ref.oldValue,
          row = _ref.row,
          rowIndex = _ref.rowIndex,
          $rowIndex = _ref.$rowIndex,
          column = _ref.column,
          columnIndex = _ref.columnIndex,
          $columnIndex = _ref.$columnIndex,
          $event = _ref.$event;
      this.$emit('radio-change', {
        newValue: newValue,
        oldValue: oldValue,
        row: row,
        rowIndex: rowIndex,
        $rowIndex: $rowIndex,
        column: column,
        columnIndex: columnIndex,
        $columnIndex: $columnIndex,
        $event: $event
      });
    },
    getCheckboxRecords: function getCheckboxRecords() {
      return this.$refs.xTable.getCheckboxRecords();
    },
    toggleCheckboxRow: function toggleCheckboxRow(row) {
      return this.$refs.xTable.toggleCheckboxRow(row);
    },
    CheckBoxChange: function CheckBoxChange(_ref2) {
      var records = _ref2.records,
          reserves = _ref2.reserves,
          indeterminates = _ref2.indeterminates,
          checked = _ref2.checked,
          row = _ref2.row,
          rowIndex = _ref2.rowIndex,
          $rowIndex = _ref2.$rowIndex,
          column = _ref2.column,
          columnIndex = _ref2.columnIndex,
          $columnIndex = _ref2.$columnIndex,
          $event = _ref2.$event;
      this.$emit('checkbox-change', {
        records: records,
        reserves: reserves,
        indeterminates: indeterminates,
        checked: checked,
        row: row,
        rowIndex: rowIndex,
        $rowIndex: $rowIndex,
        column: column,
        columnIndex: columnIndex,
        $columnIndex: $columnIndex,
        $event: $event
      });

      if (this.isTrunPage) {
        try {
          if (this.rowId != null) {
            var rowId = this.rowId;

            if (checked) {
              if (reserves.length === 0) {
                this.selectedRowKeys = records.map(function (v) {
                  return v[rowId];
                });
                this.records = records;
              } else {
                this.selectedRowKeys = [].concat(_toConsumableArray(reserves.map(function (v) {
                  return v[rowId];
                })), _toConsumableArray(records.map(function (v) {
                  return v[rowId];
                })));
                this.records = [].concat(_toConsumableArray(reserves), _toConsumableArray(records));
              }
            } else {
              var idIndex = this.selectedRowKeys.indexOf(row[rowId]);

              if (idIndex > -1) {
                this.$delete(this.selectedRowKeys, idIndex);
              }

              var dataIndex = null;

              for (var i = 0; i < this.records.length; i++) {
                if (this.records[i][rowId] === row[rowId]) {
                  dataIndex = i;
                  break;
                }
              }

              this.$delete(this.records, dataIndex);
            }

            this.$emit('checkTrunPage', {
              records: this.records,
              selectedRowKeys: this.selectedRowKeys
            });
          } else {
            util.log.danger('Property or method "rowId" is not defined on the instance but referenced during render. Make sure that this property is reactive, either in the data option, or for class-based components, by initializing the property');
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    CheckBoxAll: function CheckBoxAll(_ref3) {
      var records = _ref3.records,
          reserves = _ref3.reserves,
          indeterminates = _ref3.indeterminates,
          checked = _ref3.checked,
          $event = _ref3.$event;
      this.$emit('checkbox-all', {
        records: records,
        reserves: reserves,
        indeterminates: indeterminates,
        checked: checked,
        $event: $event
      });

      if (this.isTrunPage) {
        try {
          if (this.rowId != null) {
            var rowId = this.rowId;

            if (checked) {
              if (reserves.length === 0) {
                this.selectedRowKeys = records.map(function (v) {
                  return v[rowId];
                });
                this.records = records;
              } else {
                this.selectedRowKeys = [].concat(_toConsumableArray(reserves.map(function (v) {
                  return v[rowId];
                })), _toConsumableArray(records.map(function (v) {
                  return v[rowId];
                })));
                this.records = [].concat(_toConsumableArray(reserves), _toConsumableArray(records));
              }
            } else {
              this.records = reserves;
              this.selectedRowKeys = reserves.map(function (v) {
                return v[rowId];
              });
            }

            this.$emit('checkTrunPage', {
              records: this.records,
              selectedRowKeys: this.selectedRowKeys
            });
          } else {
            util.log.danger('Property or method "rowId" is not defined on the instance but referenced during render. Make sure that this property is reactive, either in the data option, or for class-based components, by initializing the property');
          }
        } catch (error) {}
      }
    },
    // 选中行
    CellClick: function CellClick(_ref4) {
      var row = _ref4.row,
          rowIndex = _ref4.rowIndex,
          $rowIndex = _ref4.$rowIndex,
          column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          $columnIndex = _ref4.$columnIndex,
          triggerRadio = _ref4.triggerRadio,
          triggerCheckbox = _ref4.triggerCheckbox,
          triggerTreeNode = _ref4.triggerTreeNode,
          triggerExpandNode = _ref4.triggerExpandNode,
          $event = _ref4.$event;
      this.$emit('cell-click', {
        row: row,
        rowIndex: rowIndex,
        $rowIndex: $rowIndex,
        column: column,
        columnIndex: columnIndex,
        $columnIndex: $columnIndex,
        triggerRadio: triggerRadio,
        triggerCheckbox: triggerCheckbox,
        triggerTreeNode: triggerTreeNode,
        triggerExpandNode: triggerExpandNode,
        $event: $event
      });
    },
    // 获取保存的配置
    SeniorSetting: function SeniorSetting(val) {
      this.$emit('settingColumn', val);
    },
    // 获取保存列
    SeniorColumn: function SeniorColumn() {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var val;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                val = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

                _this3.$emit('refreshReset', val);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    refreshReset: function refreshReset() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.$emit('refreshReset', flag);
    },
    customSortMethod: function customSortMethod(_ref5) {
      var column = _ref5.column,
          property = _ref5.property,
          order = _ref5.order;
      var obj = {
        property: property
      };

      if (order === 'asc') {
        obj.OrderBySort = 0;
      } else {
        obj.OrderBySort = 1;
      } // 自定义排序


      this.$emit('customSortMethod', _objectSpread({}, obj));
    },
    // 点击高级配置按钮
    handleDrawerVisible: function handleDrawerVisible() {
      var _this4 = this;

      this.$nextTick(function (_) {
        _this4.$refs.SeniorSetting.handleSearchTableLoad();
      });
    },
    // 点击高级查询按钮
    handleDialogVisible: function handleDialogVisible() {
      var _this5 = this;

      this.$nextTick(function (_) {
        _this5.$refs.SeniorSearch.handleSearchTableLoad();
      });
    },
    // 高级列配置
    handleColumnVisible: function handleColumnVisible() {
      var _this6 = this;

      this.$nextTick(function (_) {
        _this6.$refs.SeniorColumn.handleSearchTableLoad();
      });
    },
    // 基础列配置
    handleBaseColumnVisible: function handleBaseColumnVisible(event) {
      var _this7 = this;

      this.$nextTick(function (_) {
        _this7.$refs.BaseColumn.handleSearchTableLoad(true, event);
      });
    },
    // 翻页选中配置
    handleTrunPageVisible: function handleTrunPageVisible() {
      var _this8 = this;

      this.$nextTick(function (_) {
        _this8.$refs.BaseTrunPage.handleSearchTableLoad();
      });
    }
  }
};